var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"globalHeader"},[(!_vm.closeFlag)?_c('img',{attrs:{"src":require("../assets/images/rightcorner.png"),"alt":""},on:{"click":_vm.back}}):_c('van-icon',{attrs:{"name":"cross"},on:{"click":_vm.back}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e8a067b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/globalHeader.vue
// module id = null
// module chunks = 